export default __webpack_public_path__ + "static/media/Alquiler-de-maquinaria.853d384f.png";